export const translationsEn = {
	"Settings": "Settings",
};